import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_list_management_plan_type" }
];
const PlanTypeListing = Loadable({
  loader: () => import("container/management/auto/planType"),
  loading() {
    return <Loader />;
  }
});

export const planTypeRoutes: IRoute[] = [
  {
    path: "/management/plan-type",
    element: <PlanTypeListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
